import {UpgradeModalActionTypes} from "./types";

export const showUpgradeModal= () => ({
  type: UpgradeModalActionTypes.MODAL_SHOW,
});

export const hideUpgradeModal= () => ({
  type:  UpgradeModalActionTypes.MODAL_HIDE,
});
